import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const POLL_MS = 60_000;
export const RESTORE_COUNT_EVENT = 'restore-requests-changed';

// Open restore-request count for admins; refreshes every 60s and when an admin approves/declines.
export const useRestoreRequestCount = (enabled) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    const load = () => axios.get(`${API}/admin/restore-requests/count`, { withCredentials: true })
      .then((res) => { if (!cancelled) setCount(res.data.count); })
      .catch(() => {});
    load();
    const id = setInterval(load, POLL_MS);
    window.addEventListener(RESTORE_COUNT_EVENT, load);
    return () => {
      cancelled = true;
      clearInterval(id);
      window.removeEventListener(RESTORE_COUNT_EVENT, load);
    };
  }, [enabled]);

  return count;
};
